import { useEffect } from "react";
import { useWeatherLayers } from "../../hooks/map/useWeatherLayers";
import { WeatherLayerOption } from "../../types/map/types";

interface WeatherOverlayProps {
  map: google.maps.Map | null;
  weatherLayers: WeatherLayerOption[];
}

export const WeatherOverlay: React.FC<WeatherOverlayProps> = ({
  map,
  weatherLayers,
}) => {
  useWeatherLayers({
    map,
    weatherLayers,
  });

  return null;
};
